import React from "react";
import { useHistory } from "react-router-dom";

export const LeaderboardComponent = () => {
  const history = useHistory();
  const leaderboard = () => {
    history.push("/leaderboardProgressHub?tab=leaderboard");
  };
  return (
    <div className="text-align-center" onClick={leaderboard}>
      <span className="font-size-smd bold font-family-default">Leaderboard</span>
    </div>
  );
};
